import { render, staticRenderFns } from "./TelenorForYouEl.vue?vue&type=template&id=06e3cfe5&scoped=true&"
import script from "./TelenorForYouEl.vue?vue&type=script&lang=ts&"
export * from "./TelenorForYouEl.vue?vue&type=script&lang=ts&"
import style0 from "./TelenorForYouEl.vue?vue&type=style&index=0&id=06e3cfe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3cfe5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
